"use client"

import { useState } from "react"
import {
  Box,
  TextField,
  Button,
  Typography,
  Paper,
  CircularProgress,
  Card,
  CardContent,
  Avatar,
  Chip,
} from "@mui/material"
import { Send, SmartToy, Lightbulb } from "@mui/icons-material"

// TODO: integrate real LLM - POST /api/llm/query with actual query
const mockApiResponse = {
  answer:
    "This is a mock LLM response. In a real scenario, this would be generated based on your query about CSRD, leveraging information from uploaded reports and benchmark data.",
}

const suggestedQuestions = [
  "What are the key climate risks for Company A compared to Company B?",
  "Compare materiality topics across all companies",
  "Which companies have the strongest diversity commitments?",
  "Analyze water stewardship approaches across the portfolio",
]

const Chat = ({ formData, setFormData, chatData, fetchChatData, loading }) => {
  const [localQuery, setLocalQuery] = useState(formData.query || "")

  const handleQueryChange = (event) => {
    setLocalQuery(event.target.value)
  }

  const handleSubmitQuery = () => {
    if (!localQuery.trim()) return
    setFormData((prev) => ({ ...prev, query: localQuery }))
    fetchChatData(localQuery)
  }

  const handleSuggestedQuestion = (question) => {
    setLocalQuery(question)
  }

  const handleKeyPress = (event) => {
    if (event.key === "Enter" && !event.shiftKey) {
      event.preventDefault()
      handleSubmitQuery()
    }
  }

  return (
    <Box sx={{ p: 3, backgroundColor: "#fff", minHeight: "100vh" }}>
      <Box sx={{ maxWidth: "900px", margin: "auto" }}>
        <Box sx={{ mb: 4, textAlign: "center" }}>
        <Typography
            variant="h4"
            component="h1"
            sx={{
              color: "#407775",
              fontWeight: "bold",
              mb: 1,
            }}
          >
            AI Assistant for CSRD Insights
          </Typography>
          <Typography
            variant="body1"
            sx={{
              color: "#707070",
              maxWidth: "600px",
              mx: "auto",
            }}
          >
            Ask questions about CSRD compliance, company reports, and benchmark data to get intelligent insights
          </Typography>
        </Box>

        {/* Suggested Questions */}
       

        {/* Chat Input */}
        <Card
          elevation={0}
          sx={{
            mb: 3,
            border: "1px solid #e0e0e0",
            borderRadius: "12px",
          }}
        >
          <CardContent sx={{ p: 3 }}>
            <TextField
              fullWidth
              multiline
              rows={4}
              variant="outlined"
              label="Ask a question about CSRD, company reports, or benchmark data..."
              value={localQuery}
              onChange={handleQueryChange}
              onKeyPress={handleKeyPress}
              disabled={loading}
              placeholder="e.g., What are the key climate risks for Company A compared to Company B?"
              sx={{
                mb: 2,
                "& .MuiOutlinedInput-root": {
                  "&:hover fieldset": {
                    borderColor: "#407775",
                  },
                  "&.Mui-focused fieldset": {
                    borderColor: "#407775",
                  },
                },
                "& .MuiInputLabel-root.Mui-focused": {
                  color: "#407775",
                },
              }}
            />

            <Box sx={{ display: "flex", justifyContent: "flex-end" }}>
              <Button
                variant="contained"
                onClick={handleSubmitQuery}
                disabled={loading || !localQuery.trim()}
                sx={{
                  textTransform: "none",
                  backgroundColor: "#407775",
                  "&:hover": {
                    backgroundColor: "#2E5266",
                  },
                  borderRadius: "8px",
                  px: 3,
                }}
              >
                {loading ? "Thinking..." : "Ask AI"}
              </Button>
            </Box>
          </CardContent>
        </Card>

        {/* AI Response */}
        {chatData && chatData.answer && !loading && (
          <Card
            elevation={0}
            sx={{
              border: "1px solid #e0e0e0",
              borderRadius: "12px",
              backgroundColor: "white",
            }}
          >
            <CardContent sx={{ p: 3 }}>
              <Box sx={{ display: "flex", alignItems: "center", mb: 2 }}>
                <Avatar
                  sx={{
                    width: 32,
                    height: 32,
                    backgroundColor: "#407775",
                    mr: 2,
                  }}
                >
                  <SmartToy sx={{ fontSize: 18 }} />
                </Avatar>
                <Typography
                  variant="h6"
                  sx={{
                    color: "#407775",
                    fontWeight: "bold",
                  }}
                >
                  AI Response
                </Typography>
              </Box>
              <Typography
                variant="body1"
                sx={{
                  color: "#707070",
                  lineHeight: 1.6,
                  whiteSpace: "pre-wrap",
                }}
              >
                {chatData.answer}
              </Typography>
            </CardContent>
          </Card>
        )}

        {/* Disclaimer */}
      
      </Box>
    </Box>
  )
}

export default Chat
